import { graphql } from "@opensea/graphql"
import { MobilePurchaseActionsFragment } from "./MobilePurchaseActions.fragment"

export const MobileCollectionItemsActionsFragment = graphql(
  `
    fragment MobileCollectionItemsActions on Collection {
      ...MobilePurchaseActions
      slug
    }
  `,
  [MobilePurchaseActionsFragment],
)
